// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"c3c5c11f","79":"ebd21a0e","189":"b0b11419","319":"54169463","433":"ea3c8dad","438":"50676345","529":"660f7aa2","979":"21763a1e","991":"9f48a467"}[chunkId] + ".chunk.js";
};